const nl = {
    estateTeaser: {
        new: 'Nieuw',
    },
    estateNavigation: {
        previous: 'Vorige',
        overview: 'Overzicht',
        next: 'Volgende',
    },
    estateSearch: {
        loading: 'De panden worden geladen...',
        search: 'Zoek',
        emptyFilter: 'Maak filter leeg',
        noResults: 'Sorry we vonden geen resultaten voor uw zoekopdracht.',
        noResultsCTA: 'Niet gevonden wat je zocht?',
        noResultsCTADescription: 'Schrijf je in en ontvang nieuwe panden die met uw zoekcriteria overeenkomen via e-mail',
        noResultsCTAButton: 'Inschrijven',
        cheapestFirst: 'Prijs goedkoopste eerst',
        mostExpensiveFirst: 'Prijs duurste eerst',
        oldestFirst: 'Oudste eerst',
        newestFirst: 'Nieuwste eerst',
        result: 'resultaat',
        results: 'resultaten',
        showMap: 'toon kaart',
        hideMap: 'verberg kaart',
        found: 'gevonden',
        sortBy: 'Sorteer op',
        selected: 'geselecteerd',
    },
    estimateForm: {
        fields: {
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            purpose: 'Type Transactie',
            purposeOptions: {
                forSale: 'Te koop',
                forRent: 'Te huur',
            },
            category: 'Type vastgoed',
            categoryOptions: {
                house: 'Huis',
                appartment: 'Appartement',
                ground: 'Grond',
                office: 'Kantoor',
                commercial: 'Commercieel',
                industrial: 'Industrieel',
                parkingOrGarage: 'Parking of garage',
            },
            mobile: 'Telefoonnummer',
            email: 'E-mailadres',
            street: 'Straat',
            number: 'Nummer',
            box: 'Bus',
            postalCode: 'Postcode',
            city: 'Gemeente',
        },
        validation: {
            firstName: 'voornaam',
            lastName: 'achternaam',
            purpose: 'type transactie',
            category: 'type vastgoed',
            mobile: 'telefoon',
            email: 'e-mailadres',
            street: 'straat',
            number: 'nummer',
            box: 'bus',
            postalCode: 'postcode',
            city: 'gemeente',
        },
        submit: 'Verzenden',
    },
    estateSearchForm: {
        title: 'Uw wensen',
        contactTitle: 'Uw contactgegevens',
        fields: {
            purpose: 'Transactie',
            minPrice: 'Minimum prijs',
            maxPrice: 'Maximum prijs',
            locations: 'Gemeentes',
            minBedrooms: 'Minimum aantal slaapkamers',
            subCategories: 'Type',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            email: 'E-mailadres',
            mobile: 'Telefoonnummer',
        },
        validation: {
            purpose: 'transactie',
            firstName: 'voornaam',
            lastName: 'achternaam',
            email: 'e-mailadres',
            mobile: 'telefoonnummer',
            subCategories: 'type',
            minPrice: 'minimum prijs',
            maxPrice: 'maximum prijs',
            locations: 'gemeentes',
            minBedrooms: 'minimum aantal slaapkamers',
        },
        submit: 'Hou me op de hoogte',
    },
};

export { nl };
